import { render, staticRenderFns } from "./MypageDownloadHistory.vue?vue&type=template&id=194dd6ce&"
import script from "./MypageDownloadHistory.vue?vue&type=script&lang=ts&"
export * from "./MypageDownloadHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports